import { useContext } from "react";

import { UserContext } from "./UserContext";

export const useCurrentUser = () => {
    const { user, loading } =  useContext(UserContext);
    return [user, loading];
};
